/**
 * Relight API
 * Endpoint: POST /api/relight/single
 */
import apiClient, { createAuthConfig, isMockApi } from "../client";
import { appendLineageToForm } from "./studio_features";
import { appendAiImage } from "./aiUpload";

const MULTIPART = (token) => ({
  ...createAuthConfig(token),
  timeout: 300000,
  headers: {
    ...createAuthConfig(token).headers,
    "Content-Type": "multipart/form-data",
  },
});

/**
 * Relight an image.
 * @param {string} token - Clerk session token
 * @param {File|null} file - Image file (use null when sending image_url)
 * @param {object} [opts]
 * @param {string} [opts.image_url]
 * @param {string} [opts.direction] - front | left | right | top
 * @param {string} [opts.mood] - soft | natural | dramatic
 * @param {string} [opts.prompt]
 * @param {string} [opts.output_format]
 * @returns {Promise<{success: boolean, output_url?: string, credits_used?: number, remaining_credits?: number, creation_id?: string, message?: string}>}
 */
export async function relightSingle(token, file, opts = {}) {
  if (isMockApi) {
    const mockSrc = opts.image_url || (file ? URL.createObjectURL(file) : "");
    return {
      success: true,
      output_url: mockSrc || "",
      credits_used: 1,
      remaining_credits: 99,
    };
  }

  const form = new FormData();
  await appendAiImage(form, file, {
    imageUrl: opts.image_url,
    requiredMessage: "relightSingle: provide file or opts.image_url",
  });
  if (opts.direction) form.append("direction", opts.direction);
  if (opts.mood) form.append("mood", opts.mood);
  if (opts.prompt) form.append("prompt", opts.prompt);
  if (opts.output_format) form.append("output_format", opts.output_format);
  appendLineageToForm(form, opts.lineage);

  const response = await apiClient.post(
    "/api/relight/single",
    form,
    MULTIPART(token)
  );
  return response.data;
}

export default {
  relightSingle,
};
